import script from "./period-selection-lock-type-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-lock-type-dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./period-selection-lock-type-dropdown.vue?vue&type=style&index=0&id=b2e0067b&lang=css"

const __exports__ = script;

export default __exports__